import { createReducer, on, Action } from '@ngrx/store';
import { ErrorRecord } from '@/interceptors/mulesoft-error-handler/mulesoft-error.interface';
import { setPageErrorData } from './actions';

export interface State {
  errorType: 'DLMS' | 'Mulesoft' | 'None';
  name: string;
  message: string;
  errorDetails?: ErrorRecord,
  buttonAction: 'DOWNLOAD_ERROR_LOG' | 'CHANGE_USER';
}

const initialState: State = {
  errorType: 'None',
  name: '',
  message: '',
  errorDetails: undefined,
  buttonAction: 'CHANGE_USER',
};

const reducer = createReducer(
  initialState,
  on(setPageErrorData, (state: State, newState: State) => {
    if (state.errorType === 'Mulesoft') {
      return state;
    }
    return newState;
  }),
);

export function pageErrorReducer(state: typeof initialState = initialState, action: Action) {
  return reducer(state, action);
}
